import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=ae8d42d8&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"
import style0 from "./forget-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\eoninnovaction\\Development\\administracion\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8d42d8')) {
      api.createRecord('ae8d42d8', component.options)
    } else {
      api.reload('ae8d42d8', component.options)
    }
    module.hot.accept("./forget-password.vue?vue&type=template&id=ae8d42d8&", function () {
      api.rerender('ae8d42d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/components/forget-password/forget-password.vue"
export default component.exports